// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.inspection-invoice-card-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #ccc; /* Optional border */
  padding: 10px;
  background-color: white; /* White background */
  position: relative; /* For absolute positioning of the dropdown menu */
}

.inspection-invoice-card-info {
  flex-grow: 1;
  text-align: left;
  padding-bottom: 10px;
}

.inspection-invoice-card-name {
  font-weight: bold;
}

.inspection-invoice-card-actions {
  display: flex;
  align-items: center;
}

.inspection-invoice-card-menu {
  position: absolute;
  top: 100%;
  right: 0;
  transform: translateY(-125%) translateX(-25%); /* Shifts the menu up by its own height */
  background-color: #f9f9f9;
  min-width: 160px;
  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
  z-index: 2;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s, visibility 0.3s;
}

.inspection-invoice-card-menu.visible {
  opacity: 1;
  visibility: visible;
}

.menu-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  cursor: pointer;
}

.menu-item-text {
  margin-left: 10px;
  color: black; /* Or any color that contrasts well with the background */
}

.menu-item-icon {
  margin-left: auto;
}
`, "",{"version":3,"sources":["webpack://./src/components/inspection/cards/InspectionInvoiceCard.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,6BAA6B,EAAE,oBAAoB;EACnD,aAAa;EACb,uBAAuB,EAAE,qBAAqB;EAC9C,kBAAkB,EAAE,kDAAkD;AACxE;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,6CAA6C,EAAE,yCAAyC;EACxF,yBAAyB;EACzB,gBAAgB;EAChB,4CAA4C;EAC5C,UAAU;EACV,UAAU;EACV,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,YAAY,EAAE,yDAAyD;AACzE;;AAEA;EACE,iBAAiB;AACnB","sourcesContent":[".inspection-invoice-card-container {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 1px solid #ccc; /* Optional border */\n  padding: 10px;\n  background-color: white; /* White background */\n  position: relative; /* For absolute positioning of the dropdown menu */\n}\n\n.inspection-invoice-card-info {\n  flex-grow: 1;\n  text-align: left;\n  padding-bottom: 10px;\n}\n\n.inspection-invoice-card-name {\n  font-weight: bold;\n}\n\n.inspection-invoice-card-actions {\n  display: flex;\n  align-items: center;\n}\n\n.inspection-invoice-card-menu {\n  position: absolute;\n  top: 100%;\n  right: 0;\n  transform: translateY(-125%) translateX(-25%); /* Shifts the menu up by its own height */\n  background-color: #f9f9f9;\n  min-width: 160px;\n  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);\n  z-index: 2;\n  opacity: 0;\n  visibility: hidden;\n  transition: opacity 0.3s, visibility 0.3s;\n}\n\n.inspection-invoice-card-menu.visible {\n  opacity: 1;\n  visibility: visible;\n}\n\n.menu-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 12px 16px;\n  cursor: pointer;\n}\n\n.menu-item-text {\n  margin-left: 10px;\n  color: black; /* Or any color that contrasts well with the background */\n}\n\n.menu-item-icon {\n  margin-left: auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
